import React from "react"
import { questionTagShape } from "utils/propTypeShapes"
import ItemRow from "shared/ItemRow"

const QuestionTag = ({ tag }) => (
  <ItemRow
    className="dark"
    itemRowHeaderContent={(
      <span>{tag.name}</span>
    )}
  />
)

QuestionTag.propTypes = {
  tag: questionTagShape.isRequired,
}

export default QuestionTag
